import React, { Component } from 'react'
import { Alert, Button, FormControl, Glyphicon, Modal } from 'react-bootstrap'
import { connect } from 'react-redux'
import swal from 'sweetalert'
import axios from 'axios'
import getServerURL from '../../../../functions/getServerURL'
import { handleErrorFetchingData } from '../../../../functions/errorHandling'


const defaultState = {
  showModal: false,
  selectedClient: "",
  name: "",
  maxRequestTime: "",
  dataDateRange: "",
  trainingMaterials: [],
  showAlert: false
}

class NewDataSourceModal extends Component {
  state = { ...defaultState }

  handleCloseModal = () => this.setState({ ...defaultState })

  createDataSource = (dataSourceObject) => {
    const { getDataSources } = this.props

    swal({
      text: `Creating a data source... Please stand by.`,
      icon: require("../../../../static/images/spinner.gif"),
      button: false
    })
    axios.post(`${getServerURL()}access-request-data-sources/`, dataSourceObject, {
      headers: { "Authorization": `Bearer ${ localStorage.getItem("token") }` }
    }).then(response => {
      this.handleCloseModal()
      swal({
        title: "Success",
        text: `Data source ${dataSourceObject.name} has been created`,
        icon: "success",
        button: "Continue",
      })
      getDataSources(1)
    }).catch(error => {
      console.log(error, error.response)
      const message = "There was an error creating your data source"
      handleErrorFetchingData(error, message)
    })
  }

  handleSubmit = () => {
    const { selectedClient, name, maxRequestTime, dataDateRange, trainingMaterials } = this.state
    this.setState({ showAlert: false }, () => {
      if (!selectedClient || !name || !maxRequestTime || !dataDateRange) {
        this.setState({ showAlert: true })
        return
      }

      if (trainingMaterials.length) {
        const incompleteMaterial = trainingMaterials.find(material => !material.name || !material.material_url )
        if (!!incompleteMaterial) {
            this.setState({ showAlert: true })
            return
        }
      }

      let dataSourceObject = {
        client: selectedClient,
        name: name,
        max_request_time: maxRequestTime,
        data_date_range: dataDateRange,
        training_material_objects: trainingMaterials
      }

      this.createDataSource(dataSourceObject)
    })
  }

  handleAddTrainingMaterial = () => {
    const trainingMaterials = [ ...this.state.trainingMaterials, { name: "", material_url: "" } ]
    this.setState({ trainingMaterials })
  }

  handleRemoveTrainingMaterial = (index) => {
    const trainingMaterials = [ ...this.state.trainingMaterials ]
    trainingMaterials.splice(index, 1)
    this.setState({ trainingMaterials })
  }

  handleEditTrainingMaterial = (index, field, value) => {
    const trainingMaterials = [ ...this.state.trainingMaterials ]
    trainingMaterials[index][field] = value
    this.setState({ trainingMaterials })
  }

  render() {
    const { showModal, selectedClient, name, maxRequestTime, dataDateRange, trainingMaterials, showAlert } = this.state
    const { clients } = this.props

    const clientOptions = clients.map(client => {
      if (client.managed_by_genesis) {
        return (
          <option key={ client.url } value={ client.url }>
            { client.name } { client.short_code }
          </option>
        )
      } else {
        return null
      }
    })

    return (
      <div>
        <center>
          <Button onClick={ () => this.setState({ showModal: true }) }>
            New Data Source
          </Button>
        </center>
        <Modal show={ showModal } keyboard={ true }>
          <Modal.Header onHide={ this.handleCloseModal } closeButton={ true }>
            <Modal.Title>New Data Source</Modal.Title>
          </Modal.Header>
          <Modal.Body className="data-source-form">
            <div>
              <h5>
                Client: <span className="required">*</span>
              </h5>
              <FormControl
                componentClass="select"
                placeholder="select"
                value={ selectedClient }
                onChange={ (e) => this.setState({ selectedClient: e.target.value }) }
              >
                <option value="">Select a client</option>
                {clientOptions}
              </FormControl>
            </div>
            <div>
              <h5>Name: <span className="required">*</span></h5>
              <FormControl
                id="formControlProjectTitle"
                value={ name }
                onChange={(e) => this.setState({ name: e.target.value })}
                placeholder="Enter a name"
              />
            </div>
            <div>
              <h5>Duration of Access: <span className="required">*</span></h5>
              <FormControl
                id="formControlProjectTitle"
                type="number"
                value={ maxRequestTime }
                min={ 30 }
                onChange={(e) => this.setState({ maxRequestTime: e.target.value })}
                placeholder="Enter duration of access"
              />
            </div>
            <div>
              <h5>Data Date Range: <span className="required">*</span></h5>
              <FormControl
                id="formControlProjectTitle"
                value={ dataDateRange }
                onChange={(e) => this.setState({ dataDateRange: e.target.value })}
                placeholder="Enter a data date range"
              />
            </div>
            <h5>Training Materials:</h5>
            { !!trainingMaterials.length &&
              <table className="data-source-form-table" style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th><h5>Name <span className="required">*</span></h5></th>
                    <th><h5>URL <span className="required">*</span></h5></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {
                    trainingMaterials.map((trainingMaterial, index) => (
                      <tr key={index}>
                        <td style={{ padding: "0 5px 5px 0" }}>
                          <FormControl
                            id="formControlProjectTitle"
                            value={trainingMaterials[index].name}
                            onChange={(e) => this.handleEditTrainingMaterial(index, "name", e.target.value)}
                            placeholder="Enter a name"
                          />
                        </td>
                        <td style={{ padding: "0 5px 5px 0" }}>
                          <FormControl
                            id="formControlProjectTitle"
                            value={trainingMaterials[index].material_url}
                            onChange={(e) => this.handleEditTrainingMaterial(index, "material_url", e.target.value)}
                            placeholder="Enter a url"
                          />
                        </td>
                        <td style={{ padding: "0 5px 5px 0" }}>
                          <Button
                            bsStyle="danger"
                            style={{float: "right"}}
                            onClick={() => this.handleRemoveTrainingMaterial(index)}
                          >
                            <Glyphicon glyph="remove"/>
                          </Button>
                        </td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
            }
            <div>
              <Button onClick={ this.handleAddTrainingMaterial }>
                Add Training Material
              </Button>
            </div>
            { showAlert &&
              <div>
                <br/>
                <Alert
                  bsStyle="danger"
                  onDismiss={ () => this.setState({ showAlert: false }) }
                >
                  <h4>Please fill out all required fields</h4>
                  <p>
                    Required fields are marked with <span className="required">*</span>
                  </p>
                </Alert>
              </div>
            }
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={ this.handleCloseModal }>
              Cancel
            </Button>
            <Button bsStyle="primary" onClick={ this.handleSubmit }>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    clients: state.manageLogin.clients
  }
}

export default connect(mapStateToProps)(NewDataSourceModal)


// WEBPACK FOOTER //
// ./src/routes/data-access-request/DataAccessRequestManager/components/NewDataSourceModal.js